import { render, staticRenderFns } from "./BtnRow.vue?vue&type=template&id=555dbe82&lang=pug&"
import script from "./BtnRow.vue?vue&type=script&lang=js&"
export * from "./BtnRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports